import { render, staticRenderFns } from "./InputWithPostfix.vue?vue&type=template&id=f0b9a524&scoped=true"
import script from "./InputWithPostfix.vue?vue&type=script&lang=ts"
export * from "./InputWithPostfix.vue?vue&type=script&lang=ts"
import style0 from "./InputWithPostfix.vue?vue&type=style&index=0&id=f0b9a524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b9a524",
  null
  
)

export default component.exports